import Vue from 'vue'
import Router from 'vue-router'
import home from '../modules/home'
import aboutus from '../modules/aboutus'
import contactus from '../modules/contactus'
import androidhome from '../modules/androidhome'
import ioshome from '../modules/ioshome'
import topnav from '../modules/topnav'
// import footer from '../modules/footernav'


Vue.use(Router)

const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
   return originalPush.call(this, location).catch(err => err)
}

export default new Router({
  routes: [
    { path: '/', redirect: '/home'},
    {
      path: '/home',
      name: 'home',
      component: home
    },
    {
      path: '/aboutus',
      name: 'aboutus',
      component: aboutus
    },
    {
      path: '/contactus',
      name: 'contactus',
      component: contactus
    },{
      path: '/ioshome',
      name: 'ioshome',
      component: ioshome
    },{
      path: '/androidhome',
      name: 'androidhome',
      component: androidhome
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js